var _defs, _rect, _g, _path, _path2, _path3, _g2, _g3, _path4, _path5, _g4, _g5, _clipPath, _polygon, _polygon2, _polygon3, _path6, _polygon4, _polygon5, _g6, _polygon6, _g7, _g8, _g9, _path7, _g10, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlyingCoder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eH2dYj37t5p1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 120 714.08 860",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p6-fill",
    x1: 20.24,
    y1: 4.13,
    x2: 20.24,
    y2: 65.63,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p6-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p6-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p6-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p6-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p6-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p7-fill",
    x1: 287.91,
    y1: 195.69,
    x2: 287.91,
    y2: 213.5,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p7-fill-0",
    offset: "0%",
    stopColor: "#ffb072"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p7-fill-1",
    offset: "25%",
    stopColor: "#ffb87e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p7-fill-2",
    offset: "60%",
    stopColor: "#ffbe89"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p7-fill-3",
    offset: "100%",
    stopColor: "#ffc18d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p10-fill",
    x1: 234.68,
    y1: 140.47,
    x2: 217.27,
    y2: 140.47,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p10-fill-0",
    offset: "0%",
    stopColor: "#ff8f78"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p10-fill-1",
    offset: "7%",
    stopColor: "#ff947b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p10-fill-2",
    offset: "42%",
    stopColor: "#ffae88"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p10-fill-3",
    offset: "74%",
    stopColor: "#ffbd91"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p10-fill-4",
    offset: "100%",
    stopColor: "#ffc394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p15-fill",
    x1: 337.91,
    y1: 140.47,
    x2: 359.29,
    y2: 140.47,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p15-fill-0",
    offset: "0%",
    stopColor: "#ff8f78"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p15-fill-1",
    offset: "7%",
    stopColor: "#ff947b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p15-fill-2",
    offset: "42%",
    stopColor: "#ffae88"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p15-fill-3",
    offset: "74%",
    stopColor: "#ffbd91"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p15-fill-4",
    offset: "100%",
    stopColor: "#ffc394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p19-fill",
    x1: 287.91,
    y1: 62.36,
    x2: 287.91,
    y2: 202.93,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p19-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p19-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p19-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p19-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p19-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p27-fill",
    x1: 268.46,
    y1: 153.19,
    x2: 293.34,
    y2: 140.53,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p27-fill-0",
    offset: "0%",
    stopColor: "#ff8f78"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p27-fill-1",
    offset: "7%",
    stopColor: "#ff947b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p27-fill-2",
    offset: "42%",
    stopColor: "#ffae88"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p27-fill-3",
    offset: "74%",
    stopColor: "#ffbd91"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p27-fill-4",
    offset: "100%",
    stopColor: "#ffc394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p30-fill",
    x1: 286.32,
    y1: 97.91,
    x2: 286.32,
    y2: 10.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p30-fill-0",
    offset: "0%",
    stopColor: "#62361e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p30-fill-1",
    offset: "100%",
    stopColor: "#855321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p31-fill",
    x1: 190.72,
    y1: 376.59,
    x2: 85.05,
    y2: 258.26,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p31-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p31-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p31-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p31-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p31-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p32-fill",
    x1: 139.84,
    y1: 390.74,
    x2: 139.84,
    y2: 418.54,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p32-fill-0",
    offset: "0%",
    stopColor: "#ffb072"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p32-fill-1",
    offset: "25%",
    stopColor: "#ffb87e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p32-fill-2",
    offset: "60%",
    stopColor: "#ffbe89"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p32-fill-3",
    offset: "100%",
    stopColor: "#ffc18d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p33-fill",
    x1: 380.55,
    y1: 376.59,
    x2: 486.22,
    y2: 258.26,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p33-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p33-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p33-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p33-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p33-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p34-fill",
    x1: 431.38,
    y1: 390.75,
    x2: 431.38,
    y2: 418.81,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p34-fill-0",
    offset: "0%",
    stopColor: "#ffb072"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p34-fill-1",
    offset: "25%",
    stopColor: "#ffb87e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p34-fill-2",
    offset: "60%",
    stopColor: "#ffbe89"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p34-fill-3",
    offset: "100%",
    stopColor: "#ffc18d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p38-fill",
    x1: 149.78,
    y1: 413.15,
    x2: 44.11,
    y2: 294.82,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p38-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p38-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p38-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p38-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p38-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p39-fill",
    x1: 143.08,
    y1: 419.13,
    x2: 37.41,
    y2: 300.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p39-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p39-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p39-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p39-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p39-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p40-fill",
    x1: 137.25,
    y1: 424.34,
    x2: 31.58,
    y2: 306.01,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p40-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p40-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p40-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p40-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p40-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p41-fill",
    x1: 165.38,
    y1: 399.21,
    x2: 59.72,
    y2: 280.88,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p41-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p41-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p41-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p41-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p41-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p42-fill",
    x1: 157.64,
    y1: 381.23,
    x2: 209.64,
    y2: 267.23,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p42-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p42-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p45-fill",
    x1: 421.49,
    y1: 413.15,
    x2: 527.16,
    y2: 294.82,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p45-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p45-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p45-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p45-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p45-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p46-fill",
    x1: 428.19,
    y1: 419.13,
    x2: 533.86,
    y2: 300.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p46-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p46-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p46-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p46-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p46-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p47-fill",
    x1: 434.02,
    y1: 424.34,
    x2: 539.69,
    y2: 306.01,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p47-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p47-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p47-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p47-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p47-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p48-fill",
    x1: 405.89,
    y1: 399.21,
    x2: 511.55,
    y2: 280.88,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p48-fill-0",
    offset: "0%",
    stopColor: "#ffb07b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p48-fill-1",
    offset: "15%",
    stopColor: "#ffb988"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p48-fill-2",
    offset: "41%",
    stopColor: "#ffc69a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p48-fill-3",
    offset: "69%",
    stopColor: "#ffcda5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p48-fill-4",
    offset: "100%",
    stopColor: "#ffd0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p49-fill",
    x1: 413.63,
    y1: 381.23,
    x2: 361.63,
    y2: 267.23,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p49-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p49-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p50-fill",
    x1: 416.07,
    y1: 383.06,
    x2: 359.41,
    y2: 264.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p50-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p50-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p51-fill",
    x1: 285.63,
    y1: 242.49,
    x2: 285.63,
    y2: 448.53,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p51-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p51-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p57-fill",
    x1: 28.69,
    y1: 326.69,
    x2: 278.94,
    y2: 326.69,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p57-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p57-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p58-fill",
    x1: 65.83,
    y1: 324.61,
    x2: 321.65,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p58-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p58-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p59-fill",
    x1: 102.96,
    y1: 325.65,
    x2: 353.21,
    y2: 325.65,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p59-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p59-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p60-fill",
    x1: 140.1,
    y1: 324.61,
    x2: 393.89,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p60-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p60-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p61-fill",
    x1: 177.24,
    y1: 324.41,
    x2: 431.31,
    y2: 324.41,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p61-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p61-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p62-fill",
    x1: 214.37,
    y1: 322.7,
    x2: 464.62,
    y2: 322.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p62-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p62-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p63-fill",
    x1: 251.51,
    y1: 324.61,
    x2: 502.52,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p63-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p63-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p64-fill",
    x1: 288.65,
    y1: 326.49,
    x2: 538.9,
    y2: 326.49,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p64-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p64-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p66-fill",
    x1: 545.19,
    y1: 324.61,
    x2: 288.65,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p66-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p66-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p67-fill",
    x1: 501.77,
    y1: 322.7,
    x2: 251.51,
    y2: 322.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p67-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p67-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p68-fill",
    x1: 464.63,
    y1: 326.42,
    x2: 214.38,
    y2: 326.42,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p68-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p68-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p69-fill",
    x1: 427.49,
    y1: 324.61,
    x2: 173.25,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p69-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p69-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p70-fill",
    x1: 396.28,
    y1: 324.61,
    x2: 140.1,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p70-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p70-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p71-fill",
    x1: 353.22,
    y1: 324.61,
    x2: 102.97,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p71-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p71-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p72-fill",
    x1: 321.65,
    y1: 324.61,
    x2: 65.83,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p72-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p72-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p73-fill",
    x1: 278.95,
    y1: 324.61,
    x2: 24.33,
    y2: 324.61,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p73-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p73-fill-1",
    offset: "100%",
    stopColor: "#7eaee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p76-fill",
    x1: 162.04,
    y1: 373.4,
    x2: 162.04,
    y2: 399.56,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p76-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p76-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p77-fill",
    x1: 408.68,
    y1: 373.39,
    x2: 408.68,
    y2: 398.92,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p77-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p77-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p79-fill",
    x1: 306.32,
    y1: 345.5,
    x2: 351.92,
    y2: 345.5,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p79-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p79-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p82-fill",
    x1: 304.76,
    y1: 236.66,
    x2: 304.76,
    y2: 267.77,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p82-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p82-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p83-fill",
    x1: 267.68,
    y1: 236.66,
    x2: 267.68,
    y2: 267.77,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p83-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p83-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p89-fill",
    x1: 292.03,
    y1: 450.16,
    x2: 292.03,
    y2: 609.16,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p89-fill-0",
    offset: "0%",
    stopColor: "#c37e25"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p89-fill-1",
    offset: "100%",
    stopColor: "#a26b25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p115-fill",
    x1: 0,
    y1: -28.85,
    x2: 0,
    y2: 2.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p115-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p115-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p116-fill",
    x1: 0,
    y1: -28.85,
    x2: 0,
    y2: 2.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p116-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p116-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p117-fill",
    x1: 0,
    y1: -28.85,
    x2: 0,
    y2: 2.46,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p117-fill-0",
    offset: "0%",
    stopColor: "#9ac6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p117-fill-1",
    offset: "100%",
    stopColor: "#6397e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p120-fill",
    x1: 115.29,
    y1: 12.46,
    x2: 115.29,
    y2: 0.76,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p120-fill-0",
    offset: "0%",
    stopColor: "#c37e25"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p120-fill-1",
    offset: "100%",
    stopColor: "#a26b25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p121-fill",
    x1: 286.75,
    y1: 474.14,
    x2: 286.75,
    y2: 463.23,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p121-fill-0",
    offset: "0%",
    stopColor: "#bbbcbe"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p121-fill-1",
    offset: "100%",
    stopColor: "#a2a5a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p123-fill",
    x1: 285.63,
    y1: 335.24,
    x2: 285.63,
    y2: 458.27,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p123-fill-0",
    offset: "0%",
    stopColor: "#dbddde"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p123-fill-1",
    offset: "100%",
    stopColor: "#c3c6c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p124-fill",
    x1: 285.63,
    y1: 386.91,
    x2: 285.63,
    y2: 421.22,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p124-fill-0",
    offset: "0%",
    stopColor: "#bbbcbe"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p124-fill-1",
    offset: "100%",
    stopColor: "#a2a5a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p125-fill",
    x1: 230.76,
    y1: 570.11,
    x2: 230.76,
    y2: 612.95,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p125-fill-0",
    offset: "0%",
    stopColor: "#c37e25"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p125-fill-1",
    offset: "100%",
    stopColor: "#a26b25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p126-fill",
    x1: 353.31,
    y1: 570.11,
    x2: 353.31,
    y2: 612.95,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p126-fill-0",
    offset: "0%",
    stopColor: "#c37e25"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p126-fill-1",
    offset: "100%",
    stopColor: "#a26b25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p127-fill",
    x1: 245.91,
    y1: 382.79,
    x2: 245.91,
    y2: 336.43,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p127-fill-0",
    offset: "0%",
    stopColor: "#c37e25"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p127-fill-1",
    offset: "100%",
    stopColor: "#a26b25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p128-fill",
    x1: 338.16,
    y1: 382.79,
    x2: 338.16,
    y2: 336.43,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p128-fill-0",
    offset: "0%",
    stopColor: "#c37e25"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p128-fill-1",
    offset: "100%",
    stopColor: "#a26b25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p130-fill",
    x1: 259.2,
    y1: 107.37,
    x2: 265.88,
    y2: 107.37,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p130-fill-0",
    offset: "0%",
    stopColor: "#6d4121"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p130-fill-1",
    offset: "100%",
    stopColor: "#855321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p132-fill",
    x1: 310.16,
    y1: 102.22,
    x2: 317.63,
    y2: 102.22,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p132-fill-0",
    offset: "0%",
    stopColor: "#6d4121"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p132-fill-1",
    offset: "100%",
    stopColor: "#855321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p134-fill",
    x1: 317.73,
    y1: 102.95,
    x2: 325.22,
    y2: 102.95,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p134-fill-0",
    offset: "0%",
    stopColor: "#6d4121"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p134-fill-1",
    offset: "100%",
    stopColor: "#855321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p136-fill",
    x1: 254.59,
    y1: 107.37,
    x2: 261.27,
    y2: 107.37,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p136-fill-0",
    offset: "0%",
    stopColor: "#6d4121"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p136-fill-1",
    offset: "100%",
    stopColor: "#855321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p138-fill",
    x1: 215.18,
    y1: 45.74,
    x2: 242.89,
    y2: 45.74,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p138-fill-0",
    offset: "0%",
    stopColor: "#6d4121"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p138-fill-1",
    offset: "100%",
    stopColor: "#855321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p140-fill",
    x1: 235.07,
    y1: 33.22,
    x2: 250.24,
    y2: 33.22,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p140-fill-0",
    offset: "0%",
    stopColor: "#6d4121"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p140-fill-1",
    offset: "100%",
    stopColor: "#855321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH2dYj37t5p142-fill",
    x1: 254.05,
    y1: 38.52,
    x2: 259.93,
    y2: 38.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p142-fill-0",
    offset: "0%",
    stopColor: "#6d4121"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eH2dYj37t5p142-fill-1",
    offset: "100%",
    stopColor: "#855321"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "eH2dYj37t5p2",
    style: {
      isolation: "isolate"
    },
    transform: "translate(71.40499 194.077003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-48.959755)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 87.041095)"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.49,
    height: 49.63,
    rx: 0,
    ry: 0,
    transform: "translate(267.67 195.53)",
    fill: "url(#eH2dYj37t5p6-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M308.15,195.53v17.08c-4.52,1.26-9.28,1.94-14.2,1.94h-4.08c-7.93,0-15.46-1.76-22.2-4.93v-14.09h40.48Z",
    opacity: 0.45,
    fill: "url(#eH2dYj37t5p7-fill)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.99,154.54v0c-6.35,0-11.55-5.2-11.55-11.55v-5.02c0-6.35,5.2-11.55,11.55-11.55v0c6.35,0,11.55,5.2,11.55,11.55v5.02c0,6.35-5.2,11.55-11.55,11.55Z",
    fill: "url(#eH2dYj37t5p10-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.56,146.46c-.65,0-1.26-.43-1.44-1.09-1.3-4.58-5.09-8.39-9.67-9.69-.8-.23-1.26-1.06-1.03-1.85.23-.8,1.06-1.26,1.85-1.03c5.56,1.58,10.16,6.2,11.73,11.76.23.8-.24,1.63-1.04,1.85-.14.04-.27.06-.41.06Z",
    fill: "#ad7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.02,142.58c-.35,0-.71-.12-.99-.37-.62-.55-.68-1.5-.13-2.12c2.06-2.33,5.26-3.61,8.35-3.33.83.07,1.43.8,1.36,1.63s-.8,1.43-1.63,1.36c-2.17-.2-4.4.7-5.83,2.33-.3.34-.71.51-1.13.51Z",
    fill: "#ad7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.84,154.54v0c-6.35,0-11.55-5.2-11.55-11.55v-5.02c0-6.35,5.2-11.55,11.55-11.55v0c6.35,0,11.55,5.2,11.55,11.55v5.02c0,6.35-5.2,11.55-11.55,11.55Z",
    fill: "url(#eH2dYj37t5p15-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M343.68,146.46c-.14,0-.27-.02-.41-.06-.8-.23-1.26-1.05-1.04-1.85c1.57-5.56,6.18-10.18,11.74-11.76.79-.23,1.63.23,1.85,1.03.23.8-.23,1.63-1.03,1.85-4.58,1.31-8.38,5.11-9.67,9.69-.19.66-.79,1.09-1.44,1.09Z",
    fill: "#ad7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.23,142.58c-.42,0-.83-.17-1.13-.51-1.44-1.63-3.68-2.52-5.83-2.33-.84.07-1.55-.54-1.63-1.36-.07-.83.54-1.55,1.36-1.63c3.09-.28,6.3,1,8.35,3.33.55.62.49,1.57-.13,2.12-.29.25-.64.37-.99.37Z",
    fill: "#ad7552"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M343.91,86.57v70.71c0,29.76-24.12,53.89-53.89,53.89h-4.2c-29.76,0-53.89-24.13-53.89-53.89v-70.71c0-8.08,3.77-15.28,9.64-19.94c4.34-3.44,9.83-5.51,15.8-5.51h61.09c5.97,0,11.47,2.06,15.81,5.52c5.86,4.65,9.63,11.85,9.63,19.93Z",
    fill: "url(#eH2dYj37t5p19-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.22,140.32c-6.66,0-12.08-6.97-12.08-15.54c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5c0,6.91,4.07,12.54,9.08,12.54s9.08-5.62,9.08-12.54c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5c0,8.57-5.42,15.54-12.08,15.54Z",
    fill: "#ad7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.03,140.32c-6.66,0-12.08-6.97-12.08-15.54c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5c0,6.91,4.07,12.54,9.08,12.54s9.08-5.62,9.08-12.54c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5c0,8.57-5.42,15.54-12.08,15.54Z",
    fill: "#ad7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.43,101.93h18.26v3.88c0,3.86-3.14,7-7,7h-18.26v-3.88c0-3.86,3.14-7,7-7Z",
    fill: "#6d4121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,97.2h18.26c3.86,0,7,3.14,7,7v3.88h-18.26c-3.86,0-7-3.14-7-7v-3.88v0Z",
    transform: "matrix(-.995479-.094977 0.094977-.995479 625.46 235.06)",
    fill: "#6d4121"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.27,118.81c-4.17,0-9,19.34-9.89,28.2-5.01-1.8-11.25-1.27-12.72,3.77-1.58,5.41,2.58,9.23,6.12,11.31c3.45,2.03,7.22,3.33,11.08,3.51c3.24.15,7.03-.04,9.67-2.64c3.53-3.47,4.32-12.35,3.77-19.29-.61-7.73-4.05-24.87-8.03-24.87Z",
    fill: "url(#eH2dYj37t5p27-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,68.88v47.57c0,7.4-4.64,13.46-10.3,13.46v-39.73c0-8.63,4.02-16.33,10.3-21.3Z",
    fill: "#a6918a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,90.18v39.73c-5.66,0-10.29-6.06-10.29-13.46v-47.56c6.27,4.97,10.29,12.66,10.29,21.29Z",
    fill: "#a6918a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,82.03v16.66c-5.19-.97-9.3-5.13-10.29-10.43-.16-.8-.23-1.63-.23-2.48c0-.28.01-2.67.02-5.78.05-9.21-7.28-16.94-16.49-17h-65.66c-1.73.01-3.39.29-4.95.81-.65.21-1.28.46-1.89.75-2.1.99-3.95,2.41-5.46,4.15-.44.5-.85,1.03-1.22,1.59-1.89,2.76-2.99,6.12-2.97,9.7.01,3.12.02,5.5.02,5.78c0,.85-.07,1.68-.23,2.48-1,5.3-5.1,9.46-10.29,10.43v-16.05c-10.22-7.71-18.6-22.25-18.6-37.92c0-7.27,2.11-14.43,5.58-20.82.5-.92,1.03-1.82,1.58-2.71c5.13-8.19,12.48-14.83,20.3-18.38.75-.34,1.51-.66,2.27-.93c3.57-1.34,7.2-2,10.73-1.86-1.79,5.61,1.63,10.22,8.1,14.02.57.34,1.16.66,1.77.99c21.32,11.19,69.25,15.11,82.03,17.75c11.18,2.31,19.82,11.58,20.94,22.93c1.15,11.62-5.35,21.85-15.06,26.32Z",
    fill: "url(#eH2dYj37t5p30-fill)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.9,262.13c-.08-.01-7.71-1.33-15.3-2.37-14.32-1.97-19.03-2.23-19.93,2.33-1.27,6.21-2.77,12.51-4.22,18.61l-.88,3.71c-7.47,31.6-18.14,67.54-40.6,94.6-11.13,13.41-31.25,20.15-45.65,8.25-15.35-12.69-19.15-39.15-20.75-60.78-.26-3.48-.37-6.34-.45-8.42l-.23-7.95h-25.83l-.11,8.28c0,2.31-.01,5.48.12,9.44.57,17.97,2.58,41.25,13.05,62.03c2.73,5.34,5.41,9.54,8.42,13.22c3.8,4.68,8.11,8.69,12.82,11.89c10.39,7.08,21.31,10.08,31.94,10.08c19.99,0,38.97-10.58,51.51-24.42c9.02-9.96,17.34-22.56,25.43-38.52c9.39-18.53,15.8-35.91,19.81-47.37c5.57-15.96,9.89-30.39,13.2-44.14l1.86-7.75-4.21-.73Z",
    fill: "url(#eH2dYj37t5p31-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M149.22,416.8c-2.29,1.25-4.66,2.38-7.1,3.37L130.45,390.5l18.77,26.3Z",
    opacity: 0.42,
    fill: "url(#eH2dYj37t5p32-fill)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M345.36,262.13c.08-.01,7.71-1.33,15.3-2.37c14.32-1.97,19.03-2.23,19.93,2.33c1.27,6.21,2.77,12.51,4.22,18.61l.88,3.71c7.47,31.6,18.14,67.54,40.6,94.6c11.13,13.41,31.25,20.15,45.65,8.25c15.35-12.69,19.15-39.15,20.75-60.78.26-3.48.37-6.34.45-8.42l.23-7.95h25.83l.11,8.28c0,2.31.01,5.48-.12,9.44-.57,17.97-2.58,41.25-13.05,62.03-2.73,5.34-5.41,9.54-8.42,13.22-3.8,4.68-8.11,8.69-12.82,11.89-10.39,7.08-21.31,10.08-31.94,10.08-19.99,0-38.97-10.58-51.51-24.42-9.02-9.96-17.34-22.56-25.43-38.52-9.39-18.53-15.8-35.91-19.81-47.37-5.57-15.96-9.89-30.39-13.2-44.14l-1.86-7.75l4.21-.73Z",
    fill: "url(#eH2dYj37t5p33-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M440.81,390.5l-10.96,29.96c0,0-5.49-2.02-7.89-3.66l18.86-26.3Z",
    opacity: 0.42,
    fill: "url(#eH2dYj37t5p34-fill)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.92,183.74c-5,0-9.99-.64-14.84-1.9-1.07-.28-1.71-1.37-1.43-2.44s1.37-1.71,2.44-1.43c4.64,1.21,9.46,1.8,14.2,1.77c4.54-.03,9.07-.63,13.46-1.77c1.07-.28,2.16.36,2.44,1.43s-.36,2.16-1.43,2.44c-4.72,1.23-9.58,1.87-14.44,1.9-.13,0-.26,0-.4,0Z",
    fill: "#d79a6e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.5,315.49c-1.64,0-3.29-.57-4.63-1.74L17.39,280.1c-2.93-2.56-3.22-7-.67-9.93c2.56-2.93,7-3.22,9.93-.66l38.48,33.65c2.92,2.56,3.22,7,.66,9.93-1.39,1.59-3.34,2.4-5.3,2.4Z",
    fill: "url(#eH2dYj37t5p38-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.57,313.5c-.77,0-1.55-.13-2.32-.4L9.42,296.73c-3.67-1.28-5.6-5.3-4.32-8.96c1.28-3.67,5.29-5.6,8.96-4.32l46.83,16.37c3.67,1.28,5.6,5.3,4.32,8.96-1.01,2.9-3.73,4.72-6.64,4.72Z",
    fill: "url(#eH2dYj37t5p39-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.51,315.49h-53.47c-3.89,0-7.04-3.15-7.04-7.04s3.15-7.04,7.04-7.04h53.47c3.89,0,7.04,3.15,7.04,7.04s-3.15,7.04-7.04,7.04Z",
    fill: "url(#eH2dYj37t5p40-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54,271.86v0c0,3.09,1.89,5.81,4.72,7.06c4.25,1.88,7.18,6.21,6.99,11.19-.23,6.03-5.22,11.01-11.25,11.24-6.67.26-12.18-5.09-12.18-11.71c0-4.85,2.96-9.01,7.16-10.79c2.71-1.15,4.56-3.7,4.56-6.64v-.54c0-5.39-5.5-9.01-10.47-6.91-10.59,4.47-17.75,15.5-16.36,27.97c1.38,12.39,11.35,22.36,23.74,23.74c16.26,1.81,30.09-10.92,30.09-26.83c0-11.18-6.83-20.8-16.55-24.89-4.97-2.1-10.45,1.72-10.45,7.11Z",
    fill: "url(#eH2dYj37t5p41-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.7,403.81l-24.5-23.58c27.17-28.23,36.29-97.49,41.36-121.79l43.29,6.93c-.82,3.96-20.61,97.36-60.15,138.44Z",
    fill: "url(#eH2dYj37t5p42-fill)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M510.76,315.49c1.64,0,3.29-.57,4.63-1.74l38.48-33.65c2.93-2.56,3.22-7,.67-9.93-2.56-2.93-7-3.22-9.93-.66l-38.48,33.65c-2.92,2.56-3.22,7-.66,9.93c1.39,1.59,3.34,2.4,5.3,2.4Z",
    fill: "url(#eH2dYj37t5p45-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.7,313.5c.77,0,1.55-.13,2.32-.4l46.83-16.37c3.67-1.28,5.6-5.3,4.32-8.96-1.28-3.67-5.29-5.6-8.96-4.32l-46.83,16.37c-3.67,1.28-5.6,5.3-4.32,8.96c1.01,2.9,3.73,4.72,6.64,4.72Z",
    fill: "url(#eH2dYj37t5p46-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.76,315.49h53.47c3.89,0,7.04-3.15,7.04-7.04s-3.15-7.04-7.04-7.04h-53.47c-3.89,0-7.04,3.15-7.04,7.04s3.15,7.04,7.04,7.04Z",
    fill: "url(#eH2dYj37t5p47-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.72,271.86v0c0,3.09-1.89,5.81-4.72,7.06-4.25,1.88-7.18,6.21-6.99,11.19.23,6.03,5.22,11.01,11.25,11.24c6.67.26,12.18-5.09,12.18-11.71c0-4.85-2.96-9.01-7.16-10.79-2.71-1.15-4.56-3.7-4.56-6.64v-.54c0-5.39,5.5-9.01,10.47-6.91c10.59,4.47,17.75,15.5,16.36,27.97-1.38,12.39-11.35,22.36-23.74,23.74-16.26,1.81-30.09-10.92-30.09-26.83c0-11.18,6.83-20.8,16.55-24.89c4.97-2.1,10.45,1.72,10.45,7.11Z",
    fill: "url(#eH2dYj37t5p48-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.56,403.81l24.5-23.58C400.89,352,391.77,282.74,386.7,258.44l-43.29,6.93c.82,3.96,20.61,97.36,60.15,138.44Z",
    fill: "url(#eH2dYj37t5p49-fill)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M403.56,403.81l24.5-23.58C400.89,352,391.77,282.74,386.7,258.44l-43.29,6.93c.82,3.96,20.61,97.36,60.15,138.44Z",
    fill: "url(#eH2dYj37t5p50-fill)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.57,258.44l69.6-19.59c20.29-6.67,42.19-6.69,62.49-.05l70.04,19.63L350.14,468.4h-129.01L184.57,258.43Z",
    fill: "url(#eH2dYj37t5p51-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eH2dYj37t5p74)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.42
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.02,474.79 28.69,466.84 274.51,178.59 278.94,182.37 38.02,474.79",
    fill: "url(#eH2dYj37t5p57-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.26,470.62 65.83,466.84 311.64,178.59 321.65,187.12 70.26,470.62",
    fill: "url(#eH2dYj37t5p58-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.8,472.71 102.96,466.84 348.78,178.59 353.21,182.37 116.8,472.71",
    fill: "url(#eH2dYj37t5p59-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.54,470.62 140.1,466.84 385.92,178.59 393.89,185.39 144.54,470.62",
    fill: "url(#eH2dYj37t5p60-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.56,474.79 177.24,466.84 423.05,178.59 431.31,174.03 186.56,474.79",
    fill: "url(#eH2dYj37t5p61-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.81,470.62 214.37,466.84 455.71,174.77 464.62,182.37 218.81,470.62",
    fill: "url(#eH2dYj37t5p62-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.95,470.62 251.51,466.84 497.33,178.59 502.52,189.61 255.95,470.62",
    fill: "url(#eH2dYj37t5p63-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.5,474.39 288.65,466.84 534.46,178.59 538.9,182.37 297.5,474.39",
    fill: "url(#eH2dYj37t5p64-fill)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "534.46,470.62 545.18,461.48 293.08,178.59 288.65,182.37 534.46,470.62",
    fill: "url(#eH2dYj37t5p66-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.33,470.62 501.76,466.84 260.42,174.77 251.51,182.37 497.33,470.62",
    fill: "url(#eH2dYj37t5p67-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.93,474.25 464.62,466.84 218.81,178.59 214.37,182.37 455.93,474.25",
    fill: "url(#eH2dYj37t5p68-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.05,470.62 427.49,466.84 181.67,178.59 173.25,185.77 423.05,470.62",
    fill: "url(#eH2dYj37t5p69-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.92,470.62 396.28,461.78 144.54,178.59 140.1,182.37 385.92,470.62",
    fill: "url(#eH2dYj37t5p70-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.78,470.62 353.21,466.84 114.63,178.59 102.96,182.37 348.78,470.62",
    fill: "url(#eH2dYj37t5p71-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.64,470.62 321.65,463.98 70.26,178.59 65.83,182.37 311.64,470.62",
    fill: "url(#eH2dYj37t5p72-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.51,470.62 278.94,466.84 33.13,178.59 24.33,186.09 274.51,470.62",
    fill: "url(#eH2dYj37t5p73-fill)"
  }))))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "eH2dYj37t5p74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.06,380.23C400.89,352,391.77,282.74,386.7,258.44l-70.04-19.63c-20.3-6.64-42.2-6.62-62.49.05l-69.6,19.59c-5.07,24.3-14.19,93.56-41.36,121.79l24.5,23.58c13.15-13.66,24.12-33.11,32.93-53.14l20.5,117.73h129.01l20.5-117.73c8.81,20.02,19.77,39.47,32.93,53.14l24.5-23.58Z",
    fill: "none"
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "149.31,372.81 174.77,395.67 169.83,401.85 149.31,372.81",
    opacity: 0.35,
    fill: "url(#eH2dYj37t5p76-fill)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.95,372.81 395.41,394.28 401.24,401.16 421.95,372.81",
    opacity: 0.35,
    fill: "url(#eH2dYj37t5p77-fill)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.85,404.46 149.52,420.88 130.46,390.5 147.34,370.46 175.85,404.46",
    fill: "#aed1ee"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M351.92,325c0,22.64-10.21,41-22.8,41s-22.8-18.36-22.8-41h45.61Z",
    opacity: 0.35,
    fill: "url(#eH2dYj37t5p79-fill)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M351.92,321c0,22.64-10.21,41-22.8,41s-22.8-18.36-22.8-41h45.61Z",
    fill: "#aed1ee"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "327.19,249.06 297.08,264.44 282.33,234.22 320.41,229.32 327.19,249.06",
    fill: "url(#eH2dYj37t5p82-fill)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.41,248.16 275.74,264.44 288.95,234.47 252.91,228.16 246.41,248.16",
    fill: "url(#eH2dYj37t5p83-fill)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "323.08,248.16 297.08,258.44 285.63,233.84 322.42,220.34 323.08,248.16",
    fill: "#aed1ee"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.74,247.16 275.74,258.44 285.63,233.84 248.84,220.34 249.74,247.16",
    fill: "#aed1ee"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.41,404.46 421.74,420.88 440.81,390.5 423.92,370.46 395.41,404.46",
    fill: "#aed1ee"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M438.38,614.24h-116.34v-45h116.34c9.81,0,28.65-16.32,28.65-38.65s-17.34-38.65-38.65-38.65h-272.69c-21.31,0-38.65,17.34-38.65,38.65s17.34,38.65,38.65,38.65h106.34v45h-106.34c-46.13,0-83.65-37.53-83.65-83.65s37.53-83.65,83.65-83.65h272.69c46.13,0,83.65,37.53,83.65,83.65c0,21.21-7.95,41.85-22.38,58.12-14.4,16.23-33.08,25.53-51.27,25.53Z",
    fill: "url(#eH2dYj37t5p89-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M428.6,584.16h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12.08-.08c-1.71-.1-3.43-.28-5.12-.55l.47-2.96c1.59.25,3.21.43,4.82.52l-.17,3Zm280.01-.07l-.23-2.99c1.61-.12,3.23-.33,4.81-.61l.53,2.95c-1.68.3-3.4.52-5.11.65ZM140.39,581.9c-1.63-.5-3.26-1.1-4.84-1.76l1.17-2.76c1.49.63,3.02,1.18,4.56,1.66l-.88,2.87Zm304.24-.3l-.94-2.85c1.52-.5,3.04-1.09,4.52-1.74l1.22,2.74c-1.57.7-3.18,1.32-4.8,1.85Zm-315.5-4.72c-1.46-.88-2.9-1.84-4.28-2.86l1.79-2.41c1.3.96,2.65,1.87,4.03,2.69l-1.54,2.57Zm326.66-.51l-1.59-2.54c1.37-.86,2.71-1.79,3.98-2.77l1.83,2.38c-1.35,1.04-2.77,2.03-4.22,2.94Zm-336.41-7.03c-1.22-1.2-2.4-2.47-3.49-3.78l2.3-1.92c1.03,1.23,2.13,2.43,3.29,3.56l-2.1,2.14Zm346.02-.69l-2.14-2.1c1.13-1.15,2.21-2.37,3.22-3.62l2.34,1.88c-1.07,1.33-2.22,2.62-3.42,3.85Zm-353.73-8.92c-.91-1.45-1.75-2.97-2.5-4.5l2.69-1.33c.71,1.44,1.5,2.87,2.36,4.24l-2.55,1.59Zm361.26-.83l-2.58-1.54c.83-1.38,1.59-2.82,2.28-4.28l2.71,1.28c-.73,1.55-1.54,3.08-2.41,4.54ZM106.45,548.57c-.53-1.63-.99-3.3-1.36-4.97l2.93-.64c.34,1.57.77,3.14,1.28,4.67l-2.85.94Zm371.49-.94l-2.87-.88c.47-1.54.87-3.12,1.19-4.7l2.94.59c-.33,1.68-.76,3.36-1.26,4.99ZM104.05,536.47c-.1-1.28-.15-2.59-.15-3.88c0-.42,0-.84.02-1.27l3,.08c0,.4-.01.79-.01,1.19c0,1.22.05,2.45.14,3.66l-2.99.22Zm376.06-.98l-3-.17c.05-.9.08-1.82.08-2.73c0-.71-.02-1.41-.05-2.11l3-.13c.03.74.05,1.49.05,2.24c0,.97-.03,1.95-.08,2.9ZM107.56,524.65l-2.96-.49c.28-1.69.65-3.38,1.1-5.03l2.89.79c-.42,1.55-.77,3.14-1.03,4.73Zm368.82-.91c-.29-1.58-.67-3.17-1.13-4.71l2.88-.84c.48,1.64.88,3.33,1.2,5.01l-2.95.55ZM110.84,513.51l-2.75-1.19c.67-1.57,1.44-3.12,2.27-4.62l2.62,1.45c-.78,1.41-1.5,2.88-2.14,4.35Zm362.06-.84c-.66-1.46-1.41-2.91-2.22-4.31l2.6-1.51c.86,1.48,1.65,3.02,2.36,4.58l-2.73,1.24Zm-356.22-9.2l-2.4-1.8c1.03-1.37,2.14-2.7,3.3-3.95l2.21,2.03c-1.09,1.18-2.14,2.44-3.1,3.72Zm350.2-.72c-.99-1.27-2.06-2.5-3.17-3.67l2.17-2.07c1.18,1.24,2.32,2.54,3.37,3.89l-2.36,1.85Zm-342.17-7.66l-1.91-2.32c1.32-1.09,2.71-2.12,4.13-3.07l1.67,2.49c-1.34.89-2.65,1.87-3.89,2.89Zm333.97-.58c-1.26-1-2.59-1.95-3.94-2.82l1.62-2.52c1.44.92,2.85,1.93,4.19,2.99l-1.86,2.35Zm-324.2-5.69l-1.31-2.7c1.54-.75,3.14-1.42,4.74-2l1.03,2.82c-1.51.55-3.01,1.19-4.46,1.89Zm314.3-.39c-1.46-.67-2.98-1.28-4.5-1.8l.97-2.84c1.62.56,3.22,1.2,4.78,1.92l-1.25,2.72Zm-303.32-3.36l-.62-2.94c1.67-.35,3.38-.63,5.08-.81l.32,2.98c-1.61.17-3.22.43-4.78.76Zm292.27-.18c-1.58-.3-3.19-.53-4.8-.67l.27-2.99c1.71.15,3.42.39,5.1.71l-.57,2.95Zm-11.66-.86h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Zm-12,0h-5v-3h5v3Z",
    fill: "#6d4121"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 45,
    rx: 0,
    ry: 0,
    transform: "translate(287.53 446.93)",
    fill: "#6d4121"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2.5,
    rx: 0,
    ry: 0,
    transform: "translate(282.13 489.43)",
    fill: "#6d4121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.13,482.92h-3v-4.65h3v4.65Zm0-11.16h-3v-4.65h3v4.65Zm0-11.16h-3v-4.65h3v4.65Z",
    fill: "#6d4121"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2.5,
    rx: 0,
    ry: 0,
    transform: "translate(282.13 446.93)",
    fill: "#6d4121"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M292.04,588.31c0-10.48-8.5-18.98-18.98-18.98h-12.61v79.36h31.6v-60.38Z",
    fill: "#6d4121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.03,648.69h-31.6c0,15.73,12.75,28.48,28.48,28.48h3.12v-28.48Z",
    fill: "#8c6034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.04,588.31v2.32c-11.77,0-21.3-9.53-21.3-21.3h2.32c10.48,0,18.98,8.5,18.98,18.98Z",
    fill: "#8c6034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.39,577h1.64v101.66h-1.64c-.82,0-1.48-.66-1.48-1.48v-98.7c0-.82.66-1.48,1.48-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.85,618.46h-14.41c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h14.41c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.85,626.19h-14.41c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h14.41c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.85,633.93h-14.41c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h14.41c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M292.03,588.31c0-10.48,8.5-18.98,18.98-18.98h12.61v79.36h-31.6v-60.38Z",
    fill: "#6d4121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.03,648.69h31.6c0,15.73-12.75,28.48-28.48,28.48h-3.12v-28.48Z",
    fill: "#8c6034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.03,588.31v2.32c11.77,0,21.3-9.53,21.3-21.3h-2.32c-10.48,0-18.98,8.5-18.98,18.98Z",
    fill: "#8c6034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.51,577h1.64v101.66h-1.64c-.82,0-1.48-.66-1.48-1.48v-98.7c0-.82.66-1.48,1.48-1.48Z",
    transform: "matrix(-1 0 0-1 587.19 1255.66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.63,618.46h-14.41c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h14.41c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.63,626.19h-14.41c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h14.41c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.63,633.93h-14.41c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h14.41c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 3.95,
    transform: "translate(285.63 265.26)",
    fill: "url(#eH2dYj37t5p115-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.95,
    transform: "translate(285.63 296.51)",
    fill: "url(#eH2dYj37t5p116-fill)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.95,
    transform: "translate(285.63 327.76)",
    fill: "url(#eH2dYj37t5p117-fill)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply"
    },
    width: 230.59,
    height: 14.37,
    rx: 5.4,
    ry: 5.4,
    transform: "translate(171.46 466.77)",
    opacity: 0.45,
    fill: "url(#eH2dYj37t5p120-fill)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.04,462.51h211.42c2.37,0,4.29,1.92,4.29,4.29v4.83c0,2.37-1.92,4.29-4.29,4.29h-211.42c-2.37,0-4.29-1.92-4.29-4.29v-4.83c0-2.37,1.92-4.29,4.29-4.29Z",
    fill: "url(#eH2dYj37t5p121-fill)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384.68,469.03h-198.09c-1.66,0-3-1.34-3-3l-30.1-130.56c0-1.66,1.69-3,3.77-3h256.74c2.08,0,3.77,1.34,3.77,3l-30.1,130.56c0,1.66-1.34,3-3,3Z",
    fill: "url(#eH2dYj37t5p123-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.63,389.25c.29-.86,2.16-1.08,2.74-1.08c1.08,0,1.94.94,1.94,1.94c0,.5-1.44,4.39-2.23,6.7h4.03c.79,0,1.66.36,1.66,1.3c0,1.22-.79,3.17-2.09,3.17h-5.11l-2.45,6.98h3.53c1.08,0,1.15,1.01,1.15,1.87c0,1.08-.79,2.52-2.09,2.52h-4.39l-2.45,7.34c-.36.94-1.08,1.22-2.3,1.22-1.08,0-2.45-.58-2.45-1.66c0-.86,1.44-4.61,2.23-6.91h-6.19l-2.95,7.7c-.36.79-1.87.86-2.66.86-1.15,0-1.87-.86-1.87-1.87c0-.58,1.3-3.82,2.38-6.7h-3.02c-.94,0-1.51-.86-1.51-1.44c0-1.22,1.08-3.02,2.45-3.02h3.89l2.88-6.91h-4.03c-.94,0-1.3-.58-1.3-1.51c0-1.15.58-2.95,1.94-2.95h4.97l2.95-7.42c.36-1.08,1.94-1.22,2.59-1.22c1.15,0,2.09.94,2.09,1.94l-2.59,6.7h5.54l2.74-7.56Zm-4.1,12.1h-5.62l-2.88,6.84h5.98l2.52-6.84Z",
    fill: "url(#eH2dYj37t5p124-fill)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mixBlendMode: "multiply"
    },
    points: "234.88,569.24 228.76,569.24 226.63,614.32 230.76,614.32 234.88,569.24",
    opacity: 0.45,
    fill: "url(#eH2dYj37t5p125-fill)"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mixBlendMode: "multiply"
    },
    points: "349.19,569.24 355.31,569.24 357.44,614.32 353.31,614.32 349.19,569.24",
    opacity: 0.45,
    fill: "url(#eH2dYj37t5p126-fill)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262.24,567.45l-26.97-.82c-1.07-.03-1.98.79-2.06,1.86l-5.56,47.71c-.14,1.23.85,2.29,2.09,2.23l28.75-1.47c1.08.05,2.01-.76,2.09-1.84l3.58-45.5c.09-1.14-.79-2.12-1.93-2.16Z",
    fill: "url(#eH2dYj37t5p127-fill)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.83,567.45l26.97-.82c1.07-.03,1.98.79,2.06,1.86l5.56,47.71c.14,1.23-.85,2.29-2.09,2.23l-28.75-1.47c-1.08.05-2.01-.76-2.09-1.84l-3.58-45.5c-.09-1.14.79-2.12,1.93-2.16Z",
    fill: "url(#eH2dYj37t5p128-fill)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.46
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.88,101.93c-.21,1.95-.66,3.86-1.34,5.71-.69,1.83-1.62,3.57-2.75,5.17h-2.59c1.25-1.53,2.5-3.48,3.41-5.89.61-1.62,1.02-3.28,1.2-4.99h2.07Z",
    fill: "url(#eH2dYj37t5p130-fill)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.46
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M317.63,108.03l-2.9-.28c-1.36-1.78-2.45-3.74-3.24-5.83-.67-1.78-1.11-3.63-1.32-5.52l2.1.21c.21,1.57.59,3.1,1.15,4.59c1.11,2.93,2.72,5.19,4.22,6.83Z",
    fill: "url(#eH2dYj37t5p132-fill)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.46
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M325.22,108.76l-2.9-.28c-1.37-1.78-2.47-3.75-3.26-5.85-.67-1.77-1.11-3.62-1.32-5.5l2.09.19c.21,1.57.6,3.1,1.15,4.58c1.11,2.95,2.74,5.22,4.25,6.85Z",
    fill: "url(#eH2dYj37t5p134-fill)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.46
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M261.27,101.93c-.19,1.96-.65,3.87-1.34,5.71-.69,1.83-1.62,3.57-2.75,5.17h-2.59c1.25-1.53,2.5-3.48,3.42-5.89.6-1.62,1.01-3.28,1.2-4.99h2.06Z",
    fill: "url(#eH2dYj37t5p136-fill)"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M242.89,68.71c-.44.5-.85,1.03-1.22,1.59-4.67-4-9.31-8.92-13.49-14.94-7.57-10.88-11.27-22.01-13-31.46.5-.92,1.03-1.82,1.58-2.71c1.47,9.69,5.05,21.49,13.07,33.02c4.06,5.83,8.54,10.61,13.06,14.5Z",
    fill: "url(#eH2dYj37t5p138-fill)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250.24,63.81c-.65.21-1.28.46-1.89.75-4.07-6.11-7.82-13.54-10.31-22.38-4.33-15.31-3.27-29.13-.98-39.37.75-.34,1.51-.66,2.27-.93-2.44,10.11-3.78,24.14.64,39.76c2.48,8.78,6.22,16.14,10.27,22.17Z",
    fill: "url(#eH2dYj37t5p140-fill)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.13,43.49c.33,7.18,1.57,13.71,3.3,19.51h-2.1c-1.68-5.8-2.88-12.3-3.2-19.42-.51-11.31,1.36-21.31,4.03-29.54.57.34,1.16.66,1.77.99-2.53,7.96-4.29,17.59-3.8,28.46Z",
    fill: "url(#eH2dYj37t5p142-fill)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyingCoder);
export default __webpack_public_path__ + "static/media/flying-coder.b781f9d2680e5a157a0da317f94bffbf.svg";
export { ForwardRef as ReactComponent };